export const GET_ZONES_ERROR = "redux_store:zones.error.get";
export const ADD_ZONE_ERROR = "redux_store:zones.error.add";
export const DELETE_ZONE_ERROR = "redux_store:zones.error.delete";
export const UPDATE_ZONE_ERROR = "redux_store:zones.error.update";

export const GET_ZONE_ITEMS_ERROR = "redux_store:zones.error.get_items";
export const UPDATE_ZONE_ITEMS_COORDS_ERROR = "redux_store:zones.error.update_items_coords";



// WEBPACK FOOTER //
// ./src/errors/zones.js